import { Controller } from "stimulus"

export default class extends Controller {
  select(event) {
    const button = event.currentTarget
    const url = button.dataset.url

    // Remove selected state from all badges
    this.element.querySelectorAll('.model-badge').forEach(badge => {
      badge.classList.remove('selected')
    })

    // Add selected state to clicked badge
    button.classList.add('selected')

    // Fetch the turbo stream update
    fetch(url, {
      method: "GET",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.text()
    })
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
    .catch(error => {
      console.error("Error selecting model:", error)
      window.location.href = url
    })
  }
}
